import { render } from "./WhatsAppCreate.vue?vue&type=template&id=5686c1ec&scoped=true"
import script from "./WhatsAppCreate.vue?vue&type=script&lang=js"
export * from "./WhatsAppCreate.vue?vue&type=script&lang=js"

import "./WhatsAppCreate.vue?vue&type=style&index=0&id=5686c1ec&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5686c1ec"]])

export default __exports__